import React from "react"
import { useDispatch } from "react-redux"
import { hideAllForms, showAllForms } from "reduxSlices/surveyRecipientTableSlice"
import MassSelection from "shared/MassSelection"
import { SidebarCollapsibleContent } from "shared/Sidebar"
import FormList from "./FormList"

const FormFilter = () => {
  const dispatch = useDispatch()

  return (
    <SidebarCollapsibleContent title="Filter By Form">
      <div className="flex flex-col gap-2">
        <MassSelection
          deselectAll={() => dispatch(hideAllForms())}
          selectAll={() => dispatch(showAllForms())}
        />
        <FormList className="mb-4" />
      </div>
    </SidebarCollapsibleContent>
  )
}

export default FormFilter
